/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOrderRhythmFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type OrderRhythm } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/analytics/orders/rhythm
 */
export interface RhythmRequestBuilder extends BaseRequestBuilder<RhythmRequestBuilder> {
    /**
     * When orders arrive: every order in the window counted into its weekday and hour in the requested time zone, with how many of each cell came through the storefront. All 168 cells are returned, Monday midnight first and Sunday 11 pm last (weekday 0 is Monday), so busiest day and hour, after-hours share and the storefront's part in it can all be read straight off the cells.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<OrderRhythm>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<RhythmRequestBuilderGetQueryParameters> | undefined) : Promise<OrderRhythm | undefined>;
    /**
     * When orders arrive: every order in the window counted into its weekday and hour in the requested time zone, with how many of each cell came through the storefront. All 168 cells are returned, Monday midnight first and Sunday 11 pm last (weekday 0 is Monday), so busiest day and hour, after-hours share and the storefront's part in it can all be read straight off the cells.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RhythmRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * When orders arrive: every order in the window counted into its weekday and hour in the requested time zone, with how many of each cell came through the storefront. All 168 cells are returned, Monday midnight first and Sunday 11 pm last (weekday 0 is Monday), so busiest day and hour, after-hours share and the storefront's part in it can all be read straight off the cells.
 */
export interface RhythmRequestBuilderGetQueryParameters {
    /**
     * End of the window, inclusive. At most two years after the start.
     */
    endDate?: Date;
    /**
     * Start of the window, inclusive.
     */
    startDate?: Date;
    /**
     * IANA time zone the weekdays and hours are read in, e.g. America/New_York. Defaults to UTC; an unknown zone falls back to UTC.
     */
    timeZone?: string;
}
/**
 * Uri template for the request builder.
 */
export const RhythmRequestBuilderUriTemplate = "{+baseurl}/api/analytics/orders/rhythm?endDate={endDate}&startDate={startDate}{&timeZone*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const RhythmRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RhythmRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOrderRhythmFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
